export const waitTransitionEnd = (
  element: HTMLElement,
  ...properties: string[]
): {
  promise: Promise<void>
  reject: (reason?: any) => void
} => {
  let rejectPromise: void | (() => void)

  const promise: Promise<void> = new Promise((resolve, reject) => {
    rejectPromise = reject

    const callback = (event: TransitionEvent): void => {
      if (properties.indexOf(event.propertyName) > -1) {
        element.removeEventListener('transitionend', callback)
        resolve()
      }
    }

    element.addEventListener('transitionend', callback)
  })

  return {
    promise,
    reject: () => rejectPromise?.()
  }
}
